import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { UserService } from 'ish-core/services/user/user.service';
import { displayErrorMessage } from 'ish-core/store/core/messages/messages.actions';
import { loginUserSuccess } from 'ish-core/store/customer/user';
import { ApiTokenService } from 'ish-core/utils/api-token/api-token.service';
import { mapErrorToAction, mapToPayload } from 'ish-core/utils/operators';

import { SalesrepService } from '../../services/salesrep.service';

import { loadCustomerByAPIToken, salesRepActions } from './salesrep.actions';

@Injectable()
// eslint-disable-next-line ish-custom-rules/project-structure
export class SalesRepEffects {
  constructor(
    private actions$: Actions,
    private salesRepService: SalesrepService,
    private userService: UserService,
    private router: Router,
    private apiTokenService: ApiTokenService
  ) {}

  switchCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(salesRepActions.switchCustomer),
      mapToPayload(),
      concatMap(({ customerID }) =>
        this.salesRepService.switchSalesRepCustomer(customerID).pipe(
          map(() => loadCustomerByAPIToken()),
          mapErrorToAction(salesRepActions.switchCustomerFail)
        )
      )
    )
  );

  switchCustomerSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(salesRepActions.switchCustomerSuccess),
        map(() => this.router.navigate(['/account']))
      ),
    {
      dispatch: false,
    }
  );

  loadCustomerByApiTokens$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCustomerByAPIToken),
      withLatestFrom(this.apiTokenService.apiToken$),
      switchMap(([, apiToken]) =>
        this.userService
          .signInUserByToken(apiToken)
          .pipe(
            switchMap(customer =>
              customer
                ? [salesRepActions.switchCustomerSuccess(), loginUserSuccess(customer)]
                : [salesRepActions.switchCustomerFail()]
            )
          )
      )
    )
  );

  switchCustomerFail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(salesRepActions.switchCustomerFail),

      map(() =>
        displayErrorMessage({
          message: 'dias.sales_rep.switch.fail.text',
        })
      )
    )
  );
}
